/* eslint-disable */

export interface IMaybe<T> {
  get(): T | null;

  getOrElse(v: T): T;

  isDefined(): boolean;

  isEmpty(): boolean;

  map<U>(f: (opt: T) => U): IMaybe<U>;

  flatMap<U>(f: (opt: T) => IMaybe<U>): IMaybe<U>;

  then(f: (opt: T) => void): IMaybe<T>;

  else(f: () => void): IMaybe<T>;
}

export class Maybe {
  public static none<T>(): IMaybe<T> {
    return new None<T>();
  }

  public static some<T>(v: T): IMaybe<T> {
    return new Some<T>(v);
  }

  public static fromNullable<T>(v: T | undefined | null): IMaybe<T> {
    if (v !== undefined && v !== null) {
      return new Some<T>(v);
    } else {
      return new None<T>();
    }
  }
}

// tslint:disable max-classes-per-file
class None<T> implements IMaybe<T> {
  public get() {
    return null;
  }

  public getOrElse(v: T) {
    return v;
  }

  public isDefined() {
    return false;
  }

  public isEmpty() {
    return true;
  }

  public map<U>(f: (opt: T) => U): IMaybe<U> {
    return new None<U>();
  }

  public flatMap<U>(f: (opt: T) => IMaybe<U>): IMaybe<U> {
    return new None<U>();
  }

  public then(f: (opt: T) => void) {
    return this;
  } // tslint:disable-line no-empty

  public else(f: () => void) {
    f();
    return this;
  }
}

// tslint:disable max-classes-per-file
class Some<T> implements IMaybe<T> {
  private value: T;

  public constructor(v: T) {
    this.value = v;
  }

  public get() {
    return this.value;
  }

  public getOrElse(_: T) {
    return this.value;
  }

  public isDefined() {
    return true;
  }

  public isEmpty() {
    return false;
  }

  public map<U>(f: (opt: T) => U): IMaybe<U> {
    return new Some<U>(f(this.value));
  }

  public flatMap<U>(f: (opt: T) => IMaybe<U>): IMaybe<U> {
    return f(this.value);
  }

  public then(f: (opt: T) => void) {
    f(this.value);
    return this;
  }

  public else(f: () => void) {
    return this;
  } // tslint:disable-line no-empty
}
